import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routesPaths } from '@selfserve/react-utils';
import { StyledV2LinkButton } from '@selfserve/react-ui';

export const InstructionsSentContainerV2 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <StyledV2LinkButton
      type="button"
      fontSize={'16px'}
      onClick={() => navigate(routesPaths.LOGIN_V2)}
    >
      {t('common.back-to-login')}
    </StyledV2LinkButton>
  );
};
